import React from 'react';
import { useTranslation } from 'react-i18next';
import NeuralCanvas from '../NeuralCanvas';
import './PrivateSubmissionSuccess.css';

const PrivateSubmissionSuccess = () => {
    const { t } = useTranslation();

    return (
        <>
            <div style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                width: '100%', 
                height: '100%', 
                zIndex: 1 
            }}>
                <NeuralCanvas />
            </div>
            <div className="stars-bg"></div>
            <div className="private-success-container">
                <div className="private-success-content">
                    <h1>{t('privateForm.success.title')}</h1>
                    <div className="private-success-message">
                        <p>{t('privateForm.success.message')}</p>
                        <p className="private-contact-info">{t('privateForm.success.contactInfo')}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivateSubmissionSuccess; 